// xverdict routess
import Configslayout from "@/layout/config_base_layout/ConfigsLayout.vue";
import CompanyInbox from "@/views/x-verdict_views/CompanyAdmin/CompanyInboxes/CompanyInbox.vue";
import CompanyMessages from "@/views/x-verdict_views/CompanyAdmin/CompanyMessages/CompanyMessages.vue";
import PanelRegister from "@/views/x-verdict_views/CompanyAdmin/PanelRegister/PanelRegister.vue";
import TimeSheets from "@/views/x-verdict_views/CompanyAdmin/TimeSheets/TimeSheets.vue";
import AuditLog from "@/views/x-verdict_views/CompanyAdmin/Auditlog/AuditLog.vue";
import CompanyReports from "@/views/x-verdict_views/CompanyAdmin/CompanyReports/CompanyReports.vue";
import TenantSettings from "@/views/x-verdict_views/CompanyAdmin/TenantSettings/TenantSettings.vue";
import CompanyCases from "@/views/x-verdict_views/CompanyAdmin/CompanyCases/CompanyCases.vue";
import ScopeDashboard from "@/views/x-verdict_views/CompanyAdmin/CompanyCases/ScopeDashboard/ScopeDashboard.vue";
import CompanyPortfolio from "@/views/x-verdict_views/CompanyAdmin/CompanyPortfolio/CompanyPortfolio.vue";
import IntakeDesk from "@/views/x-verdict_views/IntakeOfficer/IntakeDesk/IntakeDesk.vue";
import RegisteredCases from "@/views/x-verdict_views/IntakeOfficer/RegisteredCases/RegisteredCases.vue";
import OwnerDashboard from "@/views/x-verdict_views/CaseOwner/OwnerDashboard/OwnerDashboard.vue";
import OwnerAllCases from "@/views/x-verdict_views/CaseOwner/AllCases/AllCases.vue";
import OwnerMessages from "@/views/x-verdict_views/CaseOwner/OwnerMessages/OwnerMessages.vue";
import OwnerCalendar from "@/views/x-verdict_views/CaseOwner/OwnerCalender/OwnerCalender.vue";
import OwnerTimeEntry from "@/views/x-verdict_views/CaseOwner/TimeEntry/TimeEntry.vue";
import OwnerReports from "@/views/x-verdict_views/CaseOwner/OwnerReports/OwnerReports.vue";
import RequestorDashboard from "@/views/x-verdict_views/Requestor/RequestorDashboard/RequestorDashboard.vue";
import RequestorPortal from "@/views/x-verdict_views/Requestor/RequestorPortal/RequestorPortal.vue";
import ViewCaseDetails from "@/views/x-verdict_views/ViewCaseDetails/ViewCaseDetails.vue";


const xverdicts_routes = [{
    path: "/",
    name: "GlobalConfigsBase",
    component: Configslayout,

    children: [
        {
            path: "/company-messages",
            name: "CompanyMessages",
            component: CompanyMessages
        },
        {
            path: "/company-inbox",
            name: "CompanyInbox",
            component: CompanyInbox
        },
        {
            path: "/company-inbox/main",
            name: "CoordinatorInbox",
            component: CompanyInbox
        },
        {
            path: "/company-inbox/approvals",
            name: "CoordinatorApprovals",
            component: CompanyInbox
        },
        {
            path: "/panel-register",
            name: "PanelRegister",
            component: PanelRegister
        },
        {
            path: "/time-sheets",
            name: "TimeSheets",
            component: TimeSheets
        },
        {
            path: "/audit-log",
            name: "AuditLog",
            component: AuditLog
        },
        {
            path: "/company-reports",
            name: "CompanyReports",
            component: CompanyReports
        },
        {
            path: "/tenant-settings",
            name: "TenantSettings",
            component: TenantSettings
        },
        {
            path: "/scope-dashboard",
            name: "ScopeDashboard",
            component: ScopeDashboard
        },
        {
            path: "/company-cases",
            name: "CompanyCases",
            component: CompanyCases
        },
        {
            path: "/company-cases/intake",
                        name: "CoordinatorIntake",
            component: CompanyCases
        },
        {
            path: "/company-cases/escalations",
            name: "CoordinatorEscalations",
            component: CompanyCases
        },
        {
            path: "/company-portfolio",
            name: "CompanyPortfolio",
            component: CompanyPortfolio
        },
        {
            path: "/cases/:caseCode",
            name: "ViewCaseDetails",
            component: ViewCaseDetails
        },
        {
            path: "/owner-dashboard",
            name: "OwnerDashboard",
            component: OwnerDashboard
        },
        {
            path: "/owner-queue",
            name: "OwnerQueue",
            component: OwnerAllCases
        },
        {
            path: "/owner-escalations",
            name: "OwnerEscalations",
            component: OwnerDashboard
        },
        {
            path: "/owner-approvals",
            name: "OwnerApprovals",
            component: OwnerDashboard
        },
        {
            path: "/owner-calendar",
            name: "OwnerCalendar",
            component: OwnerCalendar
        },
        {
            path: "/owner-inbox",
            name: "OwnerInbox",
            component: CompanyInbox
        },
        {
            path: "/owner-messages",
            name: "OwnerMessages",
            component: OwnerMessages
        },
        {
            path: "/owner-time-entry",
            name: "OwnerTimeEntry",
            component: OwnerTimeEntry
        },
        {
            path: "/owner-reports",
            name: "OwnerReports",
            component: OwnerReports
        },
        {
            path: "/requestor-dashboard",
            name: "RequestorDashboard",
            component: RequestorDashboard
        },
        {
            path: "/requestor-portal",
            name: "RequestorPortal",
            component: RequestorPortal,
            meta: { hideSidebar: true, hideNavbar: true }
        },
        {
            path: "/owner-decisions-due",
            name: "OwnerDecisionsDue",
            component: OwnerDashboard
        },
        {
            path: "/owner-in-review",
            name: "OwnerInReview",
            component: OwnerDashboard
        },
        {
            path: "/owner-pending-evidence",
            name: "OwnerPendingEvidence",
            component: OwnerDashboard
        },
        {
            path: "/owner-in-progress",
            name: "OwnerInProgress",
            component: OwnerDashboard
        },

        {
            path: "/cases/intake",
            name: "IntakeDesk",
            component: IntakeDesk
        },
        {
            path: "/cases/registered",
            name: "CoordinatorRegisteredCases",
            component: RegisteredCases
        },

    ]

   }
]



export default xverdicts_routes;
